import SocialSkillPage from './SocialSkillPage';
import LinearProgress from '@mui/material/LinearProgress';
import SettingsIcon from '@mui/icons-material/Settings';
import CreationSettingsPage from './CreationSettingsPage';
import axios from "axios";
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { environmentsData, visualStylesData, cognitiveLevelsData, socialSkillsData, scheduleCategoriesData, voicesData, getVoiceDisplayName, getVisualStyleDisplayName, getVoiceKeyFromDisplayName, getVisualStyleKeyFromDisplayName } from "../settings/staticData";
import {
  getCategoryDisplayName as getLocalizedCategoryDisplayName,
  getScheduleCategoryDisplayName,
  getScheduleSkillDisplayName
} from "../settings/getCategoryDisplayName";
import { FASTAPI_HOST, IS_MOBILE_APP } from '../settings/config';
import MicTranscribeButton from "../components/MicTranscribeButton";
import BuddyManagerDialog from '../components/BuddyManagerDialog';

const APP_ENVIRONMENT = String(
  process.env.REACT_APP_NODE_ENV || process.env.NODE_ENV || ''
).trim().toLowerCase();
const IS_DEVELOPMENT = APP_ENVIRONMENT === 'development';

import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Checkbox from '@mui/material/Checkbox';
import Chip from '@mui/material/Chip';
import FormControlLabel from '@mui/material/FormControlLabel';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { useTheme } from '@mui/material/styles';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ListSubheader from '@mui/material/ListSubheader';
import Collapse from '@mui/material/Collapse';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ExpandLessRoundedIcon from '@mui/icons-material/ExpandLessRounded';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import HomeIcon from '@mui/icons-material/Home';
import AutoStoriesRoundedIcon from '@mui/icons-material/AutoStoriesRounded';
import LocalLibraryIcon from '@mui/icons-material/LocalLibrary';
import PaymentIcon from '@mui/icons-material/Payment';
import CameraAltIcon from '@mui/icons-material/CameraAlt';
import EventNoteRoundedIcon from '@mui/icons-material/EventNoteRounded';
import BrushRoundedIcon from '@mui/icons-material/BrushRounded';
import ChatBubbleOutlineRoundedIcon from '@mui/icons-material/ChatBubbleOutlineRounded';
import TheaterComedyRoundedIcon from '@mui/icons-material/TheaterComedyRounded';
import LogoutIcon from '@mui/icons-material/Logout';
import LanguageRoundedIcon from '@mui/icons-material/LanguageRounded';
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import MenuBookRoundedIcon from '@mui/icons-material/MenuBookRounded';
import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';
import StoriesHubPage from './StoriesHubPage';
import AppHomePage from './AppHomePage';
import Purchase from "../components/PurchasePage";
import TextStoryPage from './TextStoryPage';
import PhotoStoryPage from './PhotoStoryPage';
import CreativeDrawingPage from './CreativeDrawingPage';
import FreeTalkPage from './FreeTalkPage';
import ScenarioPracticePage from './ScenarioPracticePage';
import SocialStoryPage from './SocialStoryPage';
import FAQPage from './FAQPage';
import ContactPage from '../components/ContactPage';
import { hasPaidPlanAccess } from '../utils/planAccess';
import useMediaQuery from '@mui/material/useMediaQuery';
const drawerWidth = 300;
const collapsedDrawerWidth = 64;
import Cookies from 'js-cookie';
import { useClerk, useUser, useAuth } from "@clerk/clerk-react";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { showStyledAlert } from '../components/StyledAlert';

const DEFAULT_VOICE = 'male';
const DEFAULT_IMAGE_STYLE = 'Gentle Storybook Manga';
const Homepage = ({
  languageCodeMap = {
    en: { code: "en", name: "English", label: "English", shortLabel: "EN", icon: "🇬🇧" },
    fr: { code: "fr", name: "French", label: "Français", shortLabel: "FR", icon: "🇫🇷" },
    'zh-TW': { code: 'zh-TW', name: 'Traditional Chinese', label: '繁體中文', shortLabel: '繁中', icon: '漢' },
    'zh-CN': { code: 'zh-CN', name: 'Simplified Chinese', label: '简体中文', shortLabel: '简中', icon: '汉' }
  },
  getValidatedName = (t) => "",
  getCategoryDisplayName = (cat) => cat,
  getImageStylesInLanguage = (lang) => ["Gentle Storybook Manga", "Watercolor", "Simple Line Comics", "Educational Comic", "Cartoon"],
  //getImageStylesInLanguage = (lang) => [ "Gentle Storybook Manga","Educational Comic"], 
  getImageStyleInEnglish = (lang, s) => s,
  selectGenderInEnglish = (g, lang) => g,
  callFastapiGenerateStory,
  callToGenerateMedia,
  userMenuPdfUrl,
  planData,
}) => {
  const navigate = useNavigate();
  const { user, isSignedIn } = useUser();
  const { signOut } = useAuth();
  // Speech-to-text language hint mode (for testing):
  // - false (default): auto-detect spoken language
  // - true: follow UI language as a hint
  const [followUiLanguageForStt, setFollowUiLanguageForStt] = useState(true);

  const [languageMenuAnchorEl, setLanguageMenuAnchorEl] = useState(null);
  const [accountMenuAnchorEl, setAccountMenuAnchorEl] = useState(null);
   // Dialog state for role settings popup
  const [roleSettingDialogOpen, setRoleSettingDialogOpen] = useState(false);
  const [buddySettingsOpen, setBuddySettingsOpen] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  // Main panel view state: 'form', 'story', 'history', 'purchase', 'terms', 'privacy', 'faq'
  const [mainPanel, setMainPanel] = React.useState('home');
  const [lastMainPanel, setLastMainPanel] = React.useState('home');
  const [understandOpen, setUnderstandOpen] = React.useState(true);
  const [practiceOpen, setPracticeOpen] = React.useState(true);
  const [expressOpen, setExpressOpen] = React.useState(true);
  const [practiceContext, setPracticeContext] = React.useState(null);
  const [storybookDialogOpen, setStorybookDialogOpen] = useState(false);
  // Responsive theme and mobile drawer state (must be before any return)
  const theme = useTheme();
  // Use react-device-detect for device detection
  // isMobileDevice is true for mobile devices
  // deviceType gives 'mobile', 'tablet', 'desktop', etc.
  // isChrome is true if browser is Chrome

  // Use isMobileDevice for mobile UI logic
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  // Set initial state for drawer: open by default on desktop, closed on mobile
  const [drawerOpen, setDrawerOpen] = React.useState(!isMobile);
  // Collapsed state for foldable sidebar
  const [collapsed, setCollapsed] = React.useState(false);
  const [sidebarContent, setSidebarContent] = React.useState('default');
  const manualInputRef = useRef(null);

  // State
  // Payment success popup state
  const [showPaymentSuccess, setShowPaymentSuccess] = useState(false);

    // User plan state
  const [userPlan, setUserPlan] = useState(null);
  const [userPlanChecked, setUserPlanChecked] = useState(false);

  // Fetch the plan after the app token is available. Clerk-to-app token recovery
  // may finish shortly after this page mounts, so retry briefly instead of
  // leaving paid users permanently locked out.
  useEffect(() => {
    let cancelled = false;
    let retryTimer;
    let attempts = 0;

    const loadPlan = async () => {
      const userToken = Cookies.get('user_token');
      if (!userToken && attempts < 20) {
        attempts += 1;
        retryTimer = window.setTimeout(loadPlan, 250);
        return;
      }
      if (!userToken) {
        if (!cancelled) setUserPlanChecked(true);
        return;
      }
      try {
        const res = await axios.get(`${FASTAPI_HOST}/api/get_plan_for_user`, {
          headers: { Authorization: `Bearer ${userToken}` },
        });
        if (!cancelled) setUserPlan(res.data?.plan_info || null);
      } catch (err) {
        if (!cancelled) setUserPlan(null);
      } finally {
        if (!cancelled) setUserPlanChecked(true);
      }
    };

    loadPlan();
    return () => {
      cancelled = true;
      if (retryTimer) window.clearTimeout(retryTimer);
    };
  }, [isSignedIn, user]);
  
  // On mount, check for payment_success param
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('payment_success') === '1') {
      console.log("Payment success detected from URL param.");
      setShowPaymentSuccess(true);
      setMainPanel('home'); // Show home page
      // Optionally, remove the param from the URL
      window.history.replaceState({}, document.title, window.location.pathname);
    }
    else if (params.get('payment_cancelled') === '1') {
      console.log("Payment cancelled detected from URL param.");
      setMainPanel('purchase'); // Show purchase page
      // Optionally, remove the param from the URL
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, []);

  const [translations, setTranslations] = useState({});
  const [language, setLanguage] = useState("English");
  const [currentLang, setCurrentLang] = useState("English");
  const [activeRoleId, setActiveRoleId] = useState(null);
  const [roleStoryLanguage, setRoleStoryLanguage] = useState("English");
  const [name, setName] = useState("");
  // Utility to map displayed gender label to English value
  const mapGenderToEnglish = (label) => {
    if (label === translations?.[currentLang]?.["sb_male"]) return "Male";
    if (label === translations?.[currentLang]?.["sb_female"]) return "Female";
    if (label === "Male" || label === "Female") return label;
    return "Male"; // fallback
  };

  const [gender, setGender] = useState(() => "Male");
  const [visualStyle, setVisualStyle] = useState(() => {
    return visualStylesData.length > 0 ? visualStylesData[0].key : "";
  });
  // Voice state for story settings
  const [voice, setVoice] = useState(() => {
    return voicesData.length > 0 ? voicesData[0].key : "";
  });
    // Image Style for story settings
  const [imageStyle, setImageStyle] = useState(() => {
    const imageStyles = getImageStylesInLanguage(currentLang);
    return imageStyles && imageStyles.length > 0 ? imageStyles[0] : '';
  });
  const [age, setAge] = useState(8);
  const [cognitiveLevel, setCognitiveLevel] = useState(() => {
    return cognitiveLevelsData.length > 0 ? cognitiveLevelsData[0].Name : "Intermediate";
  });
  const [conversationLevel, setConversationLevel] = useState("Intermediate");

  const [interest, setInterest] = useState("");
  const [pages, setPages] = useState(6);
  const [manualEnvironment, setManualEnvironment] = useState(false);
  const [environmentName] = useState('');
  const [manualSocialSkill, setManualSocialSkill] = useState(false);
  const [skillCategory, setSkillCategory] = useState("");
  const [socialSkill, setSocialSkill] = useState("");
  const [selectedPresetSkill, setSelectedPresetSkill] = useState(null);
  const [manualSocialSkillInput, setManualSocialSkillInput] = useState("");
  const [storyPages, setStoryPages] = useState([]);
  const [storyTitle, setStoryTitle] = useState("");
  const [storyRawTitle, setStoryRawTitle] = useState("");
  const [storyLanguage, setStoryLanguage] = useState("");
  const [contentType, setContentType] = useState("social_story");
  const [generatedContentType, setGeneratedContentType] = useState("social_story");
  const [loading, setLoading] = useState(false);
  const [mediaUrl, setMediaUrl] = useState("");
  const [media, setMedia] = useState([]);
  const [mediaLoading, setMediaLoading] = useState(false);
  const [mediaButtonEnabled, setMediaButtonEnabled] = useState(false);
  const activeCategoryData = contentType === "visual_schedule" ? scheduleCategoriesData : socialSkillsData;
  // Load translations.json on mount
  useEffect(() => {
    fetch("/translations.json")
      .then((res) => res.json())
      .then((data) => setTranslations(data));
  }, []);

  // Fetch user_roles and populate fields on mount (like RoleSettingPage)
  useEffect(() => {
    const userToken = Cookies.get("user_token");
    if (!userToken) return;
    // Still fetch user roles for profile fields
    axios
      .get(`${FASTAPI_HOST}/api/get_user_roles`, {
        headers: { Authorization: `Bearer ${userToken}` }
      })
      .then((res) => {
        const userRole = (res.data.user_roles && res.data.user_roles[0]) || {};
        if (userRole.name) setName(userRole.name);
        if (userRole.gender) setGender(userRole.gender);
        if (userRole.visual_style) setVisualStyle(userRole.visual_style);      
        if (userRole.age) setAge(userRole.age);
        if (userRole.interest) setInterest(userRole.interest);
        if (userRole.voice) setVoice(userRole.voice);
        setCognitiveLevel(userRole.written_language_level || userRole.cognitive_level || "Intermediate");
        setConversationLevel(userRole.conversation_level || userRole.cognitive_level || "Intermediate");
        if (userRole.image_style) setImageStyle(userRole.image_style);
        setRoleStoryLanguage(userRole.story_lang || "English");
        setActiveRoleId(res.data?.active_role_id ?? userRole.id ?? null);
      })
      .catch((err) => {
        // Optionally handle error
      });
  }, []);

  // UI language is an account preference and is independent from Role languages.
  useEffect(() => {
    const userToken = Cookies.get("user_token");
    if (!userToken) return;
    axios
      .get(`${FASTAPI_HOST}/api/user-preferences`, {
        headers: { Authorization: `Bearer ${userToken}` },
      })
      .then((res) => {
        const uiLanguage = res.data?.ui_language;
        if (uiLanguage && Object.values(languageCodeMap).some((item) => item.name === uiLanguage)) {
          setLanguage(uiLanguage);
          setCurrentLang(uiLanguage);
        }
        setPages(Number(res.data?.page_count) || 6);
        setActiveRoleId(res.data?.active_role_id ?? null);
      })
      .catch((err) => console.warn("Failed to load user preferences:", err));
  }, []);

  // Translation object with fallback
  const t = translations?.[currentLang] || {};
  const currentLanguageOption = Object.values(languageCodeMap).find((item) => item.name === currentLang)
    || Object.values(languageCodeMap)[0];
  const currentLangKey = currentLang === 'French' ? 'fr'
    : currentLang === 'Traditional Chinese' ? 'zh-TW'
      : currentLang === 'Simplified Chinese' ? 'zh-CN' : 'en';

  useEffect(() => {
    if (!selectedPresetSkill) return;
    const translatedValue = selectedPresetSkill[currentLangKey] || selectedPresetSkill.en;
    setManualSocialSkillInput(translatedValue);
    setSocialSkill(selectedPresetSkill);
  }, [currentLangKey, selectedPresetSkill]);
  useEffect(() => {
    const image_style = getImageStylesInLanguage(currentLang);
    if (image_style && image_style.length > 0) {
      setImageStyle((prev) => image_style.includes(prev) ? prev : image_style[0]);
    }
  }, [currentLang, getImageStylesInLanguage]);
  const handleContentTypeChange = (nextContentType) => {
    setContentType(nextContentType);
    setSkillCategory("");
    setSocialSkill("");
    setSelectedPresetSkill(null);
    setManualSocialSkillInput("");
    setSidebarContent("default");
    setManualSocialSkill(false);
  };
  // Handlers
  const persistUiLanguage = (uiLanguage) => {
    const userToken = Cookies.get("user_token");
    if (!userToken) return;
    axios.put(
      `${FASTAPI_HOST}/api/user-preferences`,
      { ui_language: uiLanguage },
      { headers: { Authorization: `Bearer ${userToken}` } },
    ).catch((err) => console.warn("Failed to save UI language preference:", err));
  };

  const onUiLanguageChange = (uiLanguage) => {
    setLanguage(uiLanguage);
    setCurrentLang(uiLanguage);
    persistUiLanguage(uiLanguage);
  };

  const handleLanguageChange = (lang) => {
    onUiLanguageChange(lang.name);
  };

  const handleGenerate = async () => {
    const userToken = Cookies.get('user_token');
    if (!userToken) {
      setTimeout(() => {
        if (signOut) signOut();
      }, 1500);
      return;
    }
    // Always use manualSocialSkillInput for social_skill
    if (!name.trim() ){
      showStyledAlert(t["sb_missing_name"] || "Please set up your main character's name and other details in role settings.", { severity: 'warning' });
      return;
    } else if ( !manualSocialSkillInput.trim() ) {
      showStyledAlert(t["sb_missing_required_fields"], { severity: 'warning' });
      return;
    }
    setLoading(true);
    setMediaUrl(""); // Clear previous media link when generating a new story
    setMedia([]); // Clear previous media data when generating a new story
    setMediaButtonEnabled(true); // Enable Generate Media button after generating text
    // Prepare input data
    // Normalize currentLang to match gender mapping keys
    let genderLangKey = currentLang;
    if (genderLangKey === '中文' || genderLangKey === 'zh-CN' || genderLangKey === 'Chinese') genderLangKey = 'Simplified Chinese';
    if (genderLangKey === '繁體中文' || genderLangKey === 'zh-TW' || genderLangKey === 'Traditional') genderLangKey = 'Traditional Chinese';
    if (genderLangKey === 'English' || genderLangKey === 'en') genderLangKey = 'English';
    if (genderLangKey === 'French' || genderLangKey === 'fr') genderLangKey = 'French';
    const mappedGender = selectGenderInEnglish(gender, genderLangKey);
    console.log("Selected gender (UI):", gender, "Mapped to English:", mappedGender, "LangKey:", genderLangKey);
    const inputData = {
      name,
      gender: mappedGender, // always English
      age,
      environment_name: environmentName,
      cognitive_level: cognitiveLevel,
      visual_style: visualStyle,
      skill_category: skillCategory,
      skill_category_display: contentType === "visual_schedule"
        ? getScheduleCategoryDisplayName(skillCategory)
        : getCategoryDisplayName(skillCategory),
      social_skill: manualSocialSkillInput,
      interest,
      pages,
      content_type: contentType,
      story_type: contentType === "visual_schedule" ? 2 : 1,
      manual_environment_input: manualEnvironment,
      free_style_social_skill: skillCategory === "Free_Style",
      language: roleStoryLanguage,
    };  
    try {
      const headers = { Authorization: `Bearer ${userToken}` };
      const { data } = await axios.post(
        `${FASTAPI_HOST}/api/generate_story`,
        inputData,
        { headers }
      );

      setStoryLanguage(roleStoryLanguage); // Record language used for story generation
      setStoryPages(data.pages);
      setStoryTitle(data.title);
      setStoryRawTitle(data.raw_title ?? data.title);
      setGeneratedContentType(contentType);
      // Wait for state update before opening dialog
      setTimeout(() => setStorybookDialogOpen(true), 0);
    } catch (e) {
      const err_msg = e.response?.data?.detail || e.message || "Unknown error";
      if (e.response && e.response.status === 401) {
        // e.response.data contains the response body/message
        showStyledAlert(err_msg + " Please try to sign out and sign in again.", { severity: 'warning' });
      } else {
        console.error("Error generating story:", e);
        showStyledAlert("Error: " + err_msg, { severity: 'error' });
      }
    }
    setLoading(false);
  };

  // Handler to generate media (image)
  // Accepts optional editedStoryPages and editedTitle for editable story support
  const handleGenerateMedia = async (voice, imageStyle, storyLanguage, editedStoryPages, editedTitle) => {
    const userToken = Cookies.get('user_token');
    if (!userToken) {
      setTimeout(() => {
        if (signOut) signOut();
      }, 1500);
      return;
    }
    setMediaLoading(true);
    setMediaUrl("");
    setMedia([]);
    try {
      const headers = { Authorization: `Bearer ${userToken}` };
      // Build input_data and story_pages for media generation
      const inputData = {
        name,
        gender: selectGenderInEnglish(gender, currentLang),
        age,
        environment_name: " ", //environmentName,
        cognitive_level: cognitiveLevel,
        visual_style: visualStyle,
        skill_category: skillCategory,
        skill_category_display: generatedContentType === "visual_schedule"
          ? getScheduleCategoryDisplayName(skillCategory)
          : getCategoryDisplayName(skillCategory),
        social_skill: manualSocialSkillInput,
        interest,
        pages: storyPages.length || pages,
        content_type: generatedContentType,
        story_type: generatedContentType === "visual_schedule" ? 2 : 1,
        manual_environment_input: manualEnvironment,
        free_style_social_skill: skillCategory === "Free_Style",
        language: storyLanguage,
        voice,
        image_style: imageStyle,
        story_title: storyTitle,
        raw_title: storyRawTitle,
      };
      // Prepare FormData for FastAPI endpoint
      const formData = new FormData();
      formData.append('input_data', JSON.stringify(inputData));
      // Use editedStoryPages if provided, else use current storyPages
      const pagesToSend = editedStoryPages || storyPages;
      formData.append('story_pages', JSON.stringify(pagesToSend));
      // Use editedTitle if provided, else use current storyTitle
      const titleToSend = editedTitle !== undefined ? editedTitle : storyTitle;
      if (titleToSend) formData.append('story_title', titleToSend);
      // If you want to support image upload, add: formData.append('image', file)
      console.log('[DEBUG] Media generation FormData:', formData);
      const { data } = await axios.post(
        `${FASTAPI_HOST}/api/generate_media`,
        formData,
        { headers }
      );
      setMediaUrl(data.media_url || data.image_url || data.html_url || data.static_url || "");
      setMedia(data.media || []);
      // Optionally, you can store more media info if needed
      // setMediaInfo(data);
    } catch (e) {
      const status = e.response?.status;
      // Try to extract a user-friendly error message
      let errMsg = "Unknown error";
      if (e.response?.data) {
        if (typeof e.response.data === 'string') {
          // Sometimes backend returns a string
          errMsg = e.response.data;
        } else if (e.response.data.detail) {
          errMsg = e.response.data.detail;
        } else if (e.response.data.error) {
          errMsg = e.response.data.error;
        }
      } else if (e.message) {
        errMsg = e.message;
      }

      // Custom user-friendly messages
      if (status === 401) {
        showStyledAlert((t["sb_auth_error"] || "Authentication error.") + " Please try to sign out and sign in again.", { severity: 'warning' });
      } else if (status === 429 || (errMsg && errMsg.toLowerCase().includes("limit"))) {
        showStyledAlert(t["sb_media_limit"] || "Story media generation limit has been reached. Please purchase orupgrade your plan.", { severity: 'warning' });
      } else if (errMsg && (errMsg.toLowerCase().includes("quota") || errMsg.toLowerCase().includes("plan"))) {
+        showStyledAlert(t["sb_media_quota"] || "Story media generation limit has been reached. Please purchase or upgrade your plan.", { severity: 'warning' });
      } else {
        // Fallback: show a generic error
        showStyledAlert((t["sb_media_error"] || "Failed to generate media.") + (errMsg ? `\n${errMsg}` : ""), { severity: 'error' });
      }
      console.error("[DEBUG] Backend error response:", e.response?.data || e);
    }
    setMediaLoading(false);
  };

  const handleDrawerToggle = () => {
    setDrawerOpen((prev) => {
      const next = !prev;
      console.log('DEBUG: Hamburger icon clicked, mobileOpen ->', next);
      return next;
    });
  };

  const clerk = useClerk();
  const handleLogout = async () => {
    if (isLoggingOut) return;
    setIsLoggingOut(true);
    try {
      await clerk.signOut();
    } finally {
      Cookies.remove('user_token');
      navigate('/sign-in', { replace: true });
    }
  };

  // Helper to close drawer on mobile after any sidebar action
  const closeDrawerIfMobile = () => {
    if (isMobile) setDrawerOpen(false);
  };
  const openPanel = (panel) => {
    setMainPanel(panel);
    closeDrawerIfMobile();
  };
  const sidebarSections = {
    understand: t.sidebar_understand || 'UNDERSTAND',
    practise: t.sidebar_practise || 'PRACTISE',
    express: t.sidebar_express || 'EXPRESS',
  };
  useEffect(() => {
    const stored = sessionStorage.getItem('marstrix_practice_context');
    if (!stored) return;
    try {
      const context = JSON.parse(stored);
      setPracticeContext({ ...context, requestId: Date.now() });
      setMainPanel('scenario-practice');
    } catch (error) {
      console.warn('Invalid practice context', error);
    } finally {
      sessionStorage.removeItem('marstrix_practice_context');
      if (window.location.search.includes('practice=story')) {
        window.history.replaceState({}, document.title, window.location.pathname);
      }
    }
  }, []);
  // const [showLanguageMenu, setShowLanguageMenu] = useState(false);
  // Main form content (previously drawerContent)
  // Main content area
  return (
    <Box sx={{ display: 'flex', width: '100vw', minHeight: { xs: '100dvh', sm: '100vh' } }}>
      {/* Mobile sidebar menu icon */}
      {isMobile && !drawerOpen && (
        <IconButton
          aria-label="menu"
          onClick={() => {
            setCollapsed(false); // Ensure sidebar is fully extended
            setDrawerOpen(true);
          }}
          sx={{ position: 'fixed', top: 16, left: 16, zIndex: 2000 }}
        >
          <MenuIcon sx={{ fontSize: 32 }} />
        </IconButton>
      )}
      {/* Sidebar (Drawer) as a flex child */}
      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={roleSettingDialogOpen && isMobile ? undefined : handleDrawerToggle}
        variant={isMobile ? 'temporary' : 'persistent'}
        ModalProps={roleSettingDialogOpen && isMobile ? { hideBackdrop: true } : {}}
        sx={{
          zIndex: 1400,
          width: collapsed ? collapsedDrawerWidth : drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: collapsed ? collapsedDrawerWidth : drawerWidth,
            boxSizing: 'border-box',
            overflowX: 'hidden',
            transition: 'width 0.2s',
          },
        }}
      >
        <Box
          sx={{ width: collapsed ? collapsedDrawerWidth : drawerWidth, pt: 2, display: 'flex', flexDirection: 'column', height: '100%' }}
          role="presentation"
        >
          {/* If sidebarContent is 'socialSkill', show SocialSkillPage instead of default sidebar */}
          {sidebarContent === 'socialSkill' ? (
            <SocialSkillPage
              t={t}
              skillCategory={skillCategory}
              setSkillCategory={setSkillCategory}
              socialSkill={socialSkill}
              setSocialSkill={setSocialSkill}
              socialSkillsData={activeCategoryData}
              categoryTitle={
                contentType === "visual_schedule"
                  ? (t["sb_schedule_category"] || "Schedule Category")
                  : (t["sb_skill_category"] || "Social Skill Category")
              }
              getCategoryName={
                contentType === "visual_schedule"
                  ? getScheduleCategoryDisplayName
                  : getLocalizedCategoryDisplayName
              }
              getSkillName={
                contentType === "visual_schedule"
                  ? getScheduleSkillDisplayName
                  : undefined
              }
              selectionType={contentType === "visual_schedule" ? "schedule" : "social-skill"}
              onPresetSelect={setSelectedPresetSkill}
              setManualSocialSkillInput={setManualSocialSkillInput}
              manualInputRef={manualInputRef}
              setSidebarContent={setSidebarContent}
              setCollapsed={setCollapsed}
              setManualSocialSkill={setManualSocialSkill}
              currentLang={currentLang}
            />
          ) : (
            <>
              {/* Collapse/Expand button (desktop only) */}
              {!isMobile && (
                <IconButton onClick={() => setCollapsed((prev) => !prev)} sx={{ alignSelf: 'flex-end', mb: 1 }}>
                  {collapsed ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                </IconButton>
              )}
              {/* Logo above sidebar items (hide when collapsed) */}
              {!collapsed && (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mb: 2 }}>
                  <img src="/logo.jpg" alt="Logo" style={{ maxWidth: 180, maxHeight: 90, borderRadius: 8 }} />
                </Box>
              )}
              <List sx={{ flex: 1, '& .MuiListItemButton-root': { borderRadius: 2, mx: 1, '&:hover': { bgcolor: '#E3E8DC' }, '&.Mui-selected': { bgcolor: '#EDF1DF', '&:hover': { bgcolor: '#E3E8DC' } } }, '& .MuiListItemText-primary': { fontWeight: 700 } }}>
                <ListItem disablePadding sx={{ justifyContent: collapsed ? 'center' : 'flex-start' }}>
                  <ListItemButton
                    title={t.settings_label || 'Settings'}
                    onClick={() => {
                      setRoleSettingDialogOpen(true);
                      closeDrawerIfMobile();
                    }}
                    sx={{ justifyContent: collapsed ? 'center' : 'flex-start' }}
                  >
                    <ListItemIcon sx={{ minWidth: 0, mr: collapsed ? 'auto' : 2, justifyContent: 'center' }}>
                      <SettingsIcon />
                    </ListItemIcon>
                    {!collapsed && <ListItemText primary={t.settings_label || 'Settings'} />}
                  </ListItemButton>
                </ListItem>

                <ListItem disablePadding sx={{ justifyContent: collapsed ? 'center' : 'flex-start' }}>
                  <ListItemButton selected={mainPanel === 'history'} onClick={() => openPanel('history')} sx={{ justifyContent: collapsed ? 'center' : 'flex-start' }}>
                    <ListItemIcon sx={{ minWidth: 0, mr: collapsed ? 'auto' : 2, justifyContent: 'center' }}><LocalLibraryIcon /></ListItemIcon>
                    {!collapsed && <ListItemText primary={t.sb_library || 'Library'} />}
                  </ListItemButton>
                </ListItem>

                <ListItem disablePadding sx={{ justifyContent: collapsed ? 'center' : 'flex-start' }}>
                  <ListItemButton
                    title={t.sb_check_purchase_plans || 'Purchase Plan'}
                    selected={mainPanel === 'purchase'}
                    onClick={() => {
                      setLastMainPanel(mainPanel);
                      openPanel('purchase');
                    }}
                    sx={{ justifyContent: collapsed ? 'center' : 'flex-start' }}
                  >
                    <ListItemIcon sx={{ minWidth: 0, mr: collapsed ? 'auto' : 2, justifyContent: 'center' }}><PaymentIcon /></ListItemIcon>
                    {!collapsed && <ListItemText primary={t.sb_check_purchase_plans || 'Purchase Plan'} />}
                  </ListItemButton>
                </ListItem>

                {!collapsed && <ListSubheader component="div" sx={{ mt: 2, bgcolor: 'transparent', color: '#6F7D75', fontSize: 11, fontWeight: 900, letterSpacing: '.12em', lineHeight: '34px', cursor: 'pointer' }} onClick={() => setUnderstandOpen((open) => !open)}>{sidebarSections.understand} {understandOpen ? <ExpandLessRoundedIcon sx={{ float: 'right', mt: .7, fontSize: 19 }} /> : <ExpandMoreRoundedIcon sx={{ float: 'right', mt: .7, fontSize: 19 }} />}</ListSubheader>}
                <Collapse in={collapsed || understandOpen} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <ListItemButton selected={mainPanel === 'form'} onClick={() => openPanel('form')} sx={{ pl: collapsed ? 1 : 3, justifyContent: collapsed ? 'center' : 'flex-start' }}><ListItemIcon sx={{ minWidth: 0, mr: collapsed ? 'auto' : 2 }}><AutoStoriesRoundedIcon /></ListItemIcon>{!collapsed && <ListItemText primary={t.sb_social_story || 'Social Story'} />}</ListItemButton>
                    <ListItemButton selected={mainPanel === 'visual-schedule'} onClick={() => openPanel('visual-schedule')} sx={{ pl: collapsed ? 1 : 3, justifyContent: collapsed ? 'center' : 'flex-start' }}><ListItemIcon sx={{ minWidth: 0, mr: collapsed ? 'auto' : 2 }}><EventNoteRoundedIcon /></ListItemIcon>{!collapsed && <ListItemText primary={t.sb_visual_schedule || 'Visual Schedule'} />}</ListItemButton>
                  </List>
                </Collapse>

                {!collapsed && <ListSubheader component="div" sx={{ mt: 1, bgcolor: 'transparent', color: '#6F7D75', fontSize: 11, fontWeight: 900, letterSpacing: '.12em', lineHeight: '34px', cursor: 'pointer' }} onClick={() => setPracticeOpen((open) => !open)}>{sidebarSections.practise} {practiceOpen ? <ExpandLessRoundedIcon sx={{ float: 'right', mt: .7, fontSize: 19 }} /> : <ExpandMoreRoundedIcon sx={{ float: 'right', mt: .7, fontSize: 19 }} />}</ListSubheader>}
                <Collapse in={collapsed || practiceOpen} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <ListItemButton selected={mainPanel === 'scenario-practice'} onClick={() => { setPracticeContext(null); openPanel('scenario-practice'); }} sx={{ pl: collapsed ? 1 : 3, justifyContent: collapsed ? 'center' : 'flex-start' }}><ListItemIcon sx={{ minWidth: 0, mr: collapsed ? 'auto' : 2 }}><TheaterComedyRoundedIcon /></ListItemIcon>{!collapsed && <ListItemText primary={<Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75 }}>{t.scenario_practice || 'Situation Practice'}<Chip component="span" label="Beta" size="small" color="warning" variant="outlined" sx={{ height: 18, fontSize: 10, fontWeight: 800 }} /></Box>} />}</ListItemButton>
                  </List>
                </Collapse>

                {!collapsed && <ListSubheader component="div" sx={{ mt: 1, bgcolor: 'transparent', color: '#6F7D75', fontSize: 11, fontWeight: 900, letterSpacing: '.12em', lineHeight: '34px', cursor: 'pointer' }} onClick={() => setExpressOpen((open) => !open)}>{sidebarSections.express} {expressOpen ? <ExpandLessRoundedIcon sx={{ float: 'right', mt: .7, fontSize: 19 }} /> : <ExpandMoreRoundedIcon sx={{ float: 'right', mt: .7, fontSize: 19 }} />}</ListSubheader>}
                <Collapse in={collapsed || expressOpen} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    <ListItemButton selected={mainPanel === 'photo-story'} onClick={() => openPanel('photo-story')} sx={{ pl: collapsed ? 1 : 3, justifyContent: collapsed ? 'center' : 'flex-start' }}><ListItemIcon sx={{ minWidth: 0, mr: collapsed ? 'auto' : 2 }}><CameraAltIcon /></ListItemIcon>{!collapsed && <ListItemText primary={t.sb_photo_story || 'Photo Story'} />}</ListItemButton>
                    <ListItemButton selected={mainPanel === 'creative-drawing'} onClick={() => openPanel('creative-drawing')} sx={{ pl: collapsed ? 1 : 3, justifyContent: collapsed ? 'center' : 'flex-start' }}><ListItemIcon sx={{ minWidth: 0, mr: collapsed ? 'auto' : 2 }}><BrushRoundedIcon /></ListItemIcon>{!collapsed && <ListItemText primary={<Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75 }}>{t.sb_creative_drawing || 'Talk & Draw'}<Chip component="span" label="Beta" size="small" color="warning" variant="outlined" sx={{ height: 18, fontSize: 10, fontWeight: 800 }} /></Box>} />}</ListItemButton>
                    {IS_DEVELOPMENT && <ListItemButton selected={mainPanel === 'free-talk'} onClick={() => openPanel('free-talk')} sx={{ pl: collapsed ? 1 : 3, justifyContent: collapsed ? 'center' : 'flex-start' }}><ListItemIcon sx={{ minWidth: 0, mr: collapsed ? 'auto' : 2 }}><ChatBubbleOutlineRoundedIcon /></ListItemIcon>{!collapsed && <ListItemText primary={<Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75 }}>{t.sb_free_talk || 'Free Talk'}<Chip component="span" label="Beta" size="small" color="warning" variant="outlined" sx={{ height: 18, fontSize: 10, fontWeight: 800 }} /></Box>} />}</ListItemButton>}
                  </List>
                </Collapse>

              </List>
              <Box sx={{ mt: 'auto', mb: 2, px: 1 }}>
                <ListItemButton
                  title={t.account_and_help || 'Account & help'}
                  onClick={(event) => setAccountMenuAnchorEl(event.currentTarget)}
                  sx={{ borderRadius: 2, px: collapsed ? 1 : 1.5, justifyContent: collapsed ? 'center' : 'flex-start', '&:hover': { bgcolor: '#E3E8DC' } }}
                >
                  <Box sx={{ flexShrink: 0, width: 40, height: 40, bgcolor: '#EDF1DF', borderRadius: 2, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Typography sx={{ fontWeight: 800, fontSize: 20, color: '#274D3B' }}>
                      {user?.firstName?.[0]?.toUpperCase() || user?.username?.[0]?.toUpperCase() || 'A'}
                    </Typography>
                  </Box>
                  {!collapsed && <>
                    <Box sx={{ minWidth: 0, ml: 1.25, flex: 1 }}>
                      <Typography sx={{ fontWeight: 700, fontSize: 14, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {user?.emailAddresses?.[0]?.emailAddress || user?.username || ''}
                      </Typography>
                      <Typography variant="caption" color="text.secondary">{t.account_and_help || 'Account & help'}</Typography>
                    </Box>
                    <ArrowDropDownRoundedIcon />
                  </>}
                </ListItemButton>
              </Box>
              <Menu
                anchorEl={accountMenuAnchorEl}
                open={Boolean(accountMenuAnchorEl)}
                onClose={() => setAccountMenuAnchorEl(null)}
                sx={{ zIndex: 1600 }}
                anchorOrigin={{ vertical: 'top', horizontal: isMobile ? 'left' : 'right' }}
                transformOrigin={{ vertical: 'bottom', horizontal: isMobile ? 'left' : 'left' }}
                PaperProps={{ sx: { width: 250, maxWidth: 'calc(100vw - 32px)', borderRadius: 2, boxShadow: '0 12px 36px rgba(39,77,59,.16)' } }}
              >
                <MenuItem component="a" href="/user-guide" onClick={() => setAccountMenuAnchorEl(null)}>
                  <MenuBookRoundedIcon sx={{ mr: 1.5 }} />{t.sb_user_guide || 'User Guide'}
                </MenuItem>
                <MenuItem onClick={() => { setAccountMenuAnchorEl(null); setMainPanel('faq'); closeDrawerIfMobile(); }}>
                  <HelpOutlineRoundedIcon sx={{ mr: 1.5 }} />{t.sb_faq || 'Help & FAQ'}
                </MenuItem>
                <MenuItem disabled={isLoggingOut} onClick={() => { setAccountMenuAnchorEl(null); handleLogout(); }} sx={{ color: 'text.secondary' }}>
                  <LogoutIcon sx={{ mr: 1.5 }} />{t.sb_sign_out || 'Sign Out'}
                </MenuItem>
              </Menu>
            </>
          )}
        </Box>
      </Drawer>
      {/* Main content as a flex child, fills remaining space */}
      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', height: 'auto', flex: 1 }}>
        <Box
          sx={{
            flex: 1,
            p: 2,
            boxSizing: 'border-box',
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            minHeight: 0,
          }}
        >
          {mainPanel !== 'home' && (
            <IconButton
              aria-label={currentLang === 'Simplified Chinese' ? '返回首页' : currentLang === 'Traditional Chinese' ? '返回首頁' : currentLang === 'French' ? 'Retour à l’accueil' : 'Back to Home'}
              onClick={() => setMainPanel('home')}
              sx={{
                position: 'absolute',
                top: 16,
                left: { xs: 68, sm: 24 },
                zIndex: 200,
                bgcolor: '#EDF1DF',
                color: '#1F352A',
                border: '1px solid #D6DED2',
                '&:hover': { bgcolor: '#E3E8DC' },
              }}
            >
              <HomeIcon />
            </IconButton>
          )}
          {/* Language selector */}
          <Box sx={{ position: 'absolute', top: 16, right: 24, zIndex: 200 }}>
            <Button
              id="language-menu-button"
              aria-label="Select language"
              aria-controls={languageMenuAnchorEl ? 'language-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={languageMenuAnchorEl ? 'true' : undefined}
              onClick={(event) => setLanguageMenuAnchorEl(event.currentTarget)}
              startIcon={<LanguageRoundedIcon />}
              endIcon={<ArrowDropDownRoundedIcon />}
              sx={{
                minWidth: { xs: 92, sm: 150 },
                px: { xs: 1.25, sm: 1.75 },
                py: 0.8,
                borderRadius: 999,
                color: '#1F352A',
                bgcolor: '#EDF1DF',
                border: '1px solid #D6DED2',
                boxShadow: '0 4px 12px rgba(79, 70, 229, 0.12)',
                fontWeight: 800,
                textTransform: 'none',
                '&:hover': {
                  bgcolor: '#E3E8DC',
                  borderColor: '#ACB997',
                },
              }}
            >
              {isMobile
                ? (currentLanguageOption?.shortLabel || currentLanguageOption?.code)
                : (currentLanguageOption?.label || currentLanguageOption?.name)}
            </Button>
            <Menu
              id="language-menu"
              anchorEl={languageMenuAnchorEl}
              open={Boolean(languageMenuAnchorEl)}
              onClose={() => setLanguageMenuAnchorEl(null)}
              MenuListProps={{ 'aria-labelledby': 'language-menu-button' }}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              slotProps={{
                paper: {
                  sx: {
                    mt: 1,
                    minWidth: 210,
                    borderRadius: 2.5,
                    border: '1px solid #e5e7eb',
                    boxShadow: '0 16px 32px rgba(15, 23, 42, 0.14)',
                  },
                },
              }}
            >
              {Object.values(languageCodeMap).map((lang) => {
                const selected = lang.name === currentLang;
                return (
                  <MenuItem
                    key={lang.code}
                    selected={selected}
                    onClick={() => {
                      handleLanguageChange(lang);
                      setLanguageMenuAnchorEl(null);
                    }}
                    sx={{ gap: 1.5, minHeight: 44, fontWeight: selected ? 800 : 500 }}
                  >
                    <CheckRoundedIcon
                      fontSize="small"
                      sx={{ color: '#3A6752', visibility: selected ? 'visible' : 'hidden' }}
                    />
                    {lang.label || lang.name}
                  </MenuItem>
                );
              })}
            </Menu>
          </Box>
          {/* Main Panel Content */}
          {/* Main content for each panel */}
          {mainPanel === 'home' && (
            <AppHomePage
              t={t}
              onCreateStory={() => setMainPanel('form')}
              onStartPhotoStory={() => setMainPanel('photo-story')}
              onStartVisualSchedule={() => setMainPanel('visual-schedule')}
              onStartScenario={() => { setPracticeContext(null); setMainPanel('scenario-practice'); }}
              onStartDrawing={() => setMainPanel('creative-drawing')}
            />
          )}
          {mainPanel === 'faq' && (
            <Box sx={{ width: '100%', maxWidth: 700, mx: 'auto', pt: { xs: 9, sm: 9 }, px: 2, boxSizing: 'border-box' }}>
              <FAQPage language={currentLang} />
            </Box>
          )}
          {mainPanel === 'contact' && (
            <Box sx={{ width: '100%', maxWidth: 700, mx: 'auto', mt: 4 }}>
              <ContactPage t={t}/>
            </Box>
          )}
          {(mainPanel === 'form' || mainPanel === 'visual-schedule') && (
            <>
              <Box
                sx={{
                  pb: 0,
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'flex-start',
                  maxWidth: { xs: '100%', sm: 700, md: 900, lg: 1100 },
                  width: { xs: '100%', sm: '95%', md: '90%', lg: '80%' },
                  mx: 'auto',
                  pt: { xs: 9, sm: 9 },
                  minHeight: 0,
                }}
              >
                <Box sx={{ flex: 1, width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
                  <SocialStoryPage
                    key={mainPanel}
                    currentLang={currentLang}
                    t={t}
                    name={name}
                    gender={gender}
                    age={age}
                    cognitiveLevel={cognitiveLevel}
                    visualStyle={visualStyle}
                    interest={interest}
                    pages={pages}
                    roleStoryLanguage={roleStoryLanguage}
                    voice={voice}
                    userPlan={userPlan}
                    selectGenderInEnglish={selectGenderInEnglish}
                    getCategoryDisplayName={getCategoryDisplayName}
                    mode={mainPanel === 'visual-schedule' ? 'visual_schedule' : 'social_story'}
                  />
                </Box>
                <Dialog open={showPaymentSuccess} onClose={() => setShowPaymentSuccess(false)}>
                  <DialogContent>
                    <Typography variant="h6" align="center" sx={{ mb: 2 }}>
                      Payment Successful!
                    </Typography>
                    <Typography align="center" sx={{ mb: 2 }}>
                      Thank you for your purchase. Your plan has been activated.
                    </Typography>
                    <Button variant="contained" color="inherit" onClick={() => setShowPaymentSuccess(false)} fullWidth>
                      Close
                    </Button>
                  </DialogContent>
                </Dialog>
              </Box>
            </>
          )}
          {mainPanel === 'story' && (
            <TextStoryPage
              storyTitle={storyTitle}
              storyPages={storyPages}
              storyLanguage={storyLanguage}
              voice={voice}
              imageStyle={visualStyle}
              onGenerateMedia={handleGenerateMedia}
              mediaUrl={mediaUrl}
              media={media}
              mediaLoading={mediaLoading}
              t={t}
              userPlan={userPlan}
              contentType={generatedContentType}
              disableGenerateMedia={!mediaButtonEnabled}
              renderMediaProgressBar={mediaLoading ? (
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <LinearProgress sx={{ flex: 1, mr: 2, minWidth: 120 }} />
                  <Typography variant="body2" sx={{ minWidth: 100 }}>Generating media...</Typography>
                </Box>
              ) : null}
            />
          )}
          {mainPanel === 'photo-story' && (
            <PhotoStoryPage
              currentLang={currentLang}
              onUiLanguageChange={onUiLanguageChange}
              onPurchase={() => setMainPanel('purchase')}
            />
          )}
          {mainPanel === 'creative-drawing' && (
            <CreativeDrawingPage
              currentLang={currentLang}
              childName={name}
              childAge={age}
              childInterest={interest}
              roleLanguage={roleStoryLanguage}
              conversationLevel={conversationLevel}
              paidAccess={userPlanChecked && hasPaidPlanAccess(userPlan)}
              planChecked={userPlanChecked}
              onPurchase={() => setMainPanel('purchase')}
            />
          )}
          {IS_DEVELOPMENT && mainPanel === 'free-talk' && (
            <FreeTalkPage
              currentLang={currentLang}
              childName={name}
              childAge={age}
              childInterest={interest}
              roleLanguage={roleStoryLanguage}
              conversationLevel={conversationLevel}
              paidAccess={userPlanChecked && hasPaidPlanAccess(userPlan)}
              planChecked={userPlanChecked}
              onPurchase={() => setMainPanel('purchase')}
            />
          )}
          {mainPanel === 'scenario-practice' && (
            <ScenarioPracticePage
              currentLang={currentLang}
              childName={name}
              childAge={age}
              childInterest={interest}
              roleLanguage={roleStoryLanguage}
              conversationLevel={conversationLevel}
              paidAccess={userPlanChecked && hasPaidPlanAccess(userPlan)}
              planChecked={userPlanChecked}
              translations={t}
              onPurchase={() => setMainPanel('purchase')}
              initialPractice={practiceContext}
            />
          )}
          {mainPanel === 'history' && (
            <Box sx={{ width: '100%', maxWidth: 900, mx: 'auto', pt: { xs: 9, sm: 9 }, px: 2, boxSizing: 'border-box', flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
              <StoriesHubPage t={t} allowPublic={!IS_MOBILE_APP} />
            </Box>
          )}
          {mainPanel === 'purchase' && (
            <Box sx={{ width: '100%', maxWidth: 1200, mx: 'auto', mt: 4, flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'flex-start' }}>
              <Purchase {...{ planData, language, t }} />
            </Box>
          )}
          {/* Progress bar popup while generating story */}
          <Dialog open={loading} maxWidth="xs" fullWidth sx={{ zIndex: 2500 }}>
            <DialogContent sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 4 }}>
              <LinearProgress sx={{ width: '100%', mb: 2 }} />
              <Typography variant="h6" align="center">
                {t["social_story_generating_lbl"] || "Generating story..."}
              </Typography>
            </DialogContent>
          </Dialog>
        </Box>
        {/* Shared Footer for all panels - always at the bottom */}
        <Box sx={{
          width: '100%',
          bgcolor: 'background.paper',
          borderTop: '1px solid #eee',
          py: 2,
          px: 2,
          textAlign: 'center',
          fontSize: 14,
          color: 'text.secondary',
          mt: 'auto', // Push footer to bottom if content is short
        }}>
          © 2026 Marstrix. All rights reserved. |
          <a
            href={`https://www.marstrix.com/terms?returnTo=${encodeURIComponent(`${window.location.origin}/protected`)}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#3A6752', margin: '0 8px', textDecoration: 'underline' }}
          >
            Terms and Conditions
          </a>
          |
          <a
            href={`https://www.marstrix.com/privacy?returnTo=${encodeURIComponent(`${window.location.origin}/protected`)}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#3A6752', margin: '0 8px', textDecoration: 'underline' }}
          >
            Privacy Policy
          </a>
          |
          <span style={{ cursor: 'pointer', color: '#3A6752', margin: '0 8px', textDecoration: 'underline' }}
            onClick={() => setMainPanel('contact')}
          >
            Contact Us
          </span>
        </Box>
      </Box>
      {/* Role Setting Dialog rendered at main panel level */}
      <Dialog open={roleSettingDialogOpen} onClose={() => setRoleSettingDialogOpen(false)} sx={{ zIndex: 2000 }} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: 3, maxHeight: '88vh', bgcolor: '#FDFEFC' } }}>
        <DialogContent sx={{ p: { xs: 1.5, sm: 2 } }}>
          <CreationSettingsPage
            name={name}
            setName={setName}
            gender={gender}
            setGender={setGender}
            visualStyle={visualStyle}
            setVisualStyle={setVisualStyle}
            age={age}
            setAge={setAge}
            interest={interest}
            setInterest={setInterest}
            voice={voice}
            setVoice={setVoice}
            cognitiveLevel={cognitiveLevel}
            setCognitiveLevel={setCognitiveLevel}
            conversationLevel={conversationLevel}
            setConversationLevel={setConversationLevel}
            pages={pages}
            setPages={setPages}
            imageStyle={imageStyle}
            setImageStyle={setImageStyle}
            getImageStylesInLanguage={getImageStylesInLanguage}
            cognitiveLevelsData={cognitiveLevelsData}
            currentLang={currentLang}
            t={t}
            onClose={() => setRoleSettingDialogOpen(false)}
            visualStylesData={visualStylesData}
            voicesData={voicesData}
            onUiLanguageChange={onUiLanguageChange}
            suppressSessionExpiredAlert={isLoggingOut}
            roleId={activeRoleId}
            setRoleId={setActiveRoleId}
            storyLanguage={roleStoryLanguage}
            setStoryLanguage={setRoleStoryLanguage}
            onOpenBuddySettings={() => {
              setRoleSettingDialogOpen(false);
              setBuddySettingsOpen(true);
            }}
          />
        </DialogContent>
      </Dialog>
      <BuddyManagerDialog open={buddySettingsOpen} onClose={() => setBuddySettingsOpen(false)} currentLang={currentLang} t={t} />
      <Dialog open={storybookDialogOpen} onClose={() => setStorybookDialogOpen(false)} maxWidth="md" fullWidth sx={{ zIndex: 2200 }}>
        <DialogContent sx={{ position: 'relative', p: { xs: 0, sm: 3 }, mt: { xs: '56px', sm: 0 } }}>
          <TextStoryPage
            storyTitle={storyTitle}
            storyPages={storyPages}
            storyLanguage={storyLanguage}
            voice={voice}
            imageStyle={visualStyle}
            onGenerateMedia={handleGenerateMedia}
            mediaUrl={mediaUrl}
            media={media}
            mediaLoading={mediaLoading}
            t={t}
            userPlan={userPlan}
            contentType={generatedContentType}
            disableGenerateMedia={
              !mediaButtonEnabled ||
              (!!mediaUrl && !mediaLoading && !/\.(jpg|jpeg|png|gif|webp)$/i.test(mediaUrl))
            }
            renderMediaProgressBar={mediaLoading ? (
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <LinearProgress sx={{ flex: 1, mr: 2, minWidth: 120 }} />
                <Typography variant="body2" sx={{ minWidth: 100 }}>Generating media...</Typography>
              </Box>
            ) : null}
            onClose={() => setStorybookDialogOpen(false)}
          />
          {/* Mobile action bar for media actions */}
          {/* Media action bar removed from dialog; now handled in TextStoryPage */}
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default Homepage;
